import { AutopilotTaskDto } from '@urbanx/agx.activities.client';

type TaskModalPageTask = AutopilotTaskDto & { id: string };

export interface TaskModalPage {
  task: TaskModalPageTask;
  // Usually the displayed task; Agreement Compliance can assign hidden tasks to the same page.
  completionTasks: AutopilotTaskDto[];
}

export const createTaskModalPages = (tasks: AutopilotTaskDto[]): TaskModalPage[] =>
  tasks.map((task) => {
    if (!task.id) throw new Error('Task modal page task is missing an ID');

    return {
      task: task as TaskModalPageTask,
      completionTasks: [task],
    };
  });

export const resolveTaskModalPageCompletion = (
  pages: TaskModalPage[],
  incompletePageTaskIds: string[] = []
): boolean[] =>
  pages.map(
    (page) =>
      !incompletePageTaskIds.includes(page.task.id) &&
      page.completionTasks.every(
        (task) =>
          (task.taskSteps?.length ?? 0) > 0 && task.taskSteps?.every((step) => step.isCompleted)
      )
  );
